module.exports = __webpack_public_path__ + "static/img/banner-bg.5e104b96.png";